module.exports = __webpack_public_path__ + "img/headBg3.d58dfdb1.jpg";